import { Thread, Threads } from "@/models/Thread";
import { makeStyles, Text, tokens } from "@fluentui/react-components";
import * as React from "react";
import { ThreadLink } from "./ThreadLink";

type Props = {
  heading: string;
  threads: Threads;
};

export const ThreadGroup: React.FC<Props> = ({ heading, threads }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Text className={classes.heading}>{heading}</Text>
      <div className={classes.threadLinks}>
        {threads.map((thread: Thread) => {
          return <ThreadLink key={thread.id} thread={thread}></ThreadLink>;
        })}
      </div>
    </div>
  );
};
const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  heading: {
    display: "block",
    fontSize: tokens.fontSizeBase200,
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalM}`,
    color: tokens.colorNeutralForeground3,
  },
  threadLinks: {
    display: "flex",
    flexDirection: "column",
  },
});
